import { render, staticRenderFns } from "./AttendanceLeaveUpdate.vue?vue&type=template&id=38992174&scoped=true"
import script from "./AttendanceLeaveUpdate.vue?vue&type=script&lang=js"
export * from "./AttendanceLeaveUpdate.vue?vue&type=script&lang=js"
import style0 from "./AttendanceLeaveUpdate.vue?vue&type=style&index=0&id=38992174&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38992174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38992174')) {
      api.createRecord('38992174', component.options)
    } else {
      api.reload('38992174', component.options)
    }
    module.hot.accept("./AttendanceLeaveUpdate.vue?vue&type=template&id=38992174&scoped=true", function () {
      api.rerender('38992174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/AttendanceLeaveUpdate.vue"
export default component.exports